import { configureStore } from '@reduxjs/toolkit'
import accountReducer from './accountSlice'
import addressReducer from './addressSlice'
import eyewearResultsReducer from './eyewearResultsSlice'
import lookReducer from './lookSlice'

export default configureStore({
  reducer: {
    account: accountReducer,
    address: addressReducer,
    eyewearResults: eyewearResultsReducer,
    look: lookReducer,
  },
})
